import {
  Textarea as CTextarea,
  TextareaProps as CTextareaProps,
  FormControl,
  FormControlProps,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
} from "@chakra-ui/react";
import { FC, forwardRef } from "react";
import { Text } from "../Text";

export interface TextareaProps extends CTextareaProps {
  name: string;
  value?: any;
  helperText?: string;
  label: string;
  error?: string;
  isRequired?: boolean;
  isInvalid?: boolean;
  controlProps?: FormControlProps;
}

export const Textarea: FC<TextareaProps> = forwardRef(
  (
    {
      name,
      value,
      label,
      helperText,
      isDisabled = false,
      isRequired = false,
      isInvalid = false,
      error,
      controlProps = { mb: 6 },
      ...rest
    },
    ref
  ) => {
    return (
      <FormControl
        isDisabled={isDisabled}
        isRequired={isRequired}
        isInvalid={isInvalid}
        {...controlProps}
      >
        <FormLabel as={Text}>{label}</FormLabel>
        <CTextarea value={value ?? undefined} ref={ref} name={name} {...rest} />
        <FormErrorMessage>{error}</FormErrorMessage>
        <FormHelperText>{helperText}</FormHelperText>
      </FormControl>
    );
  }
);
